export default __webpack_public_path__ + "static/media/heart.adb858b6.svg";